export default __webpack_public_path__ + "static/media/step3correct.f52f85af.png";